import { render, staticRenderFns } from "./unallocatedClients.pug?vue&type=template&id=7325dd68&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./unallocatedClients.scss?vue&type=style&index=0&id=7325dd68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7325dd68",
  null
  
)

export default component.exports